import { render } from "./QuizCategory.vue?vue&type=template&id=27cbc0e8&scoped=true"
import script from "./QuizCategory.vue?vue&type=script&lang=js"
export * from "./QuizCategory.vue?vue&type=script&lang=js"

import "./QuizCategory.vue?vue&type=style&index=0&id=27cbc0e8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27cbc0e8"]])

export default __exports__